<template>
    <!-- Main navbar -->
    <div
        class="navbar navbar-lg navbar-expand-md navbar-dark navbar-custom-bg"
        :style="{ 'background-color': topbar_color }"
    >
        <div class="d-flex flex-1 d-lg-none">
            <button class="navbar-toggler" type="button" @click="toggleMobileSidebar">
                <i class="icon-paragraph-justify3"></i>
            </button>
            <button class="navbar-toggler" type="button" @click="toggleNavbarMobile">
                <i class="icon-sort"></i>
            </button>
        </div>

        <div class="navbar-brand d-flex justify-content-lg-start align-items-center">
            <a :href="(topbar.logo && topbar.logo.link ? topbar.logo.link : '#')" class="d-inline-flex">
                <img v-if="topbar.logo && topbar.logo.src" :src="topbar.logo.src" alt="Interstellar">
                <span v-else>{{ (app.name ? app.name : 'Laravel' ) }}</span>
            </a>
        </div>

        <div class="collapse navbar-collapse order-2 order-lg-1" :class="{ show: show_mobile_navbar }">
            <div class="d-none d-lg-block">
                <a href="#" class="navbar-nav-link sidebar-control" @click.prevent="toggleMainSidebar">
                    <i class="icon-paragraph-justify3"></i>
                </a>
            </div>

            <span v-if="app.env && app.env !== 'production'" class="badge badge-success my-3 my-lg-0 mx-3">{{ app.env }}</span>

            <slot name="content"></slot>

            <ul class="navbar-nav ml-auto">
                <slot name="content-navbar"></slot>
            </ul>
        </div>

        <ul v-if="user" class="navbar-nav flex-row order-1 order-lg-2 flex-1 flex-lg-0 justify-content-end align-items-center">
            <slot name="user-navbar"></slot>
            <li class="nav-item nav-item-dropdown-lg dropdown dropdown-user h-100">
                <a href="#" class="navbar-nav-link navbar-nav-link-toggler dropdown-toggle d-inline-flex align-items-center h-100 py-0" data-toggle="dropdown">
                    <img :src="'//www.gravatar.com/avatar/' + md5(user.email) + '?d=mm'" class="rounded-pill mr-lg-2" height="34" :alt="user.email">
                    <span class="d-none d-lg-inline-block">{{ user.name }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                    <a href="/logout" class="dropdown-item"><i class="icon-switch2 mr-2"></i>Logga ut</a>
                </div>
            </li>
        </ul>
    </div>
    <!-- /main navbar -->
</template>

<script>
import { mapState } from 'pinia';
import md5 from 'md5';
import eventBus from '@services/EventBus.js';
import { useLayoutHandlerStore } from '@services/pinia/LayoutHandlerStore';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    name: 'LimitlessPageTop',
    methods: {
        md5,
        toggleMainSidebar() {
            eventBus.$emit('toggle:sidebar-main');
        },
        toggleMobileSidebar() {
            eventBus.$emit('toggle:sidebar-mobile');
        },
        toggleNavbarMobile() {
            this.show_mobile_navbar = !this.show_mobile_navbar;
        },
    },
    data: () => ({
        show_mobile_navbar: false,
    }),
    computed: {
        ...mapState(useAuthStore, ['user']),
        ...mapState(useLayoutHandlerStore, ['topbar', 'app', 'override']),
        topbar_color() {
            // eslint-disable-next-line no-nested-ternary
            return (this.override.topbar_color ? this.override.topbar_color : (this.topbar.color ? this.topbar.color : 'inherit'));
        },
    },
};
</script>

<style>
.navbar-custom-bg .navbar-nav-link:hover, .navbar-custom-bg .navbar-nav-link:focus {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.15);
}
</style>
